import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-primary-500">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-white mb-3">
          {t('cta.title')}
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-8">
          {t('cta.subtitle')}
        </p>
        <Link
          to="/category/xinshou-rumen"
          className="inline-flex items-center gap-2 px-8 py-3 rounded-md bg-white text-primary-600 font-medium text-sm whitespace-nowrap hover:bg-white/90 transition-all duration-200"
        >
          {t('cta.button')}
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}